module.exports = __webpack_public_path__ + "img/BPPMP6.2e61d216.png";